import React, { Component } from 'react';
import { graphql } from 'react-apollo';
import Spinner from '../../../spinner/spinner';
import { ROLES } from "../../../authorization/roles";
import { getCurrentChurchPastors } from './queries/pastors';
import { PastorCard } from '../../../common/pastorCard/pastorCard';

class PastorsPage extends Component {
  get pastorsList() {
    const church = this.props.data.church;
    return([church.seniorPastor].concat(church.pastors.edges.map(edges => edges.node)));
  }

  decoratePastor = (pastor) => {
    const currentUserLabel = pastor.id === this.props.user.id ? "(Me)" : null;
    const confirmationLabel = pastor.passwordCreated ? null : " - Account is not confirmed yet";
    const roleLabel = pastor.type === ROLES.seniorPastor ? "SENIOR PASTOR" : null;
    return { ...pastor, currentUserLabel, confirmationLabel, roleLabel };
  };

  render() {
    if (this.props.data.loading) {
      return <Spinner />;
    } else {
      return(
        <div className="m-24">
          <h2 className="dashboard-section-title">Pastors</h2>
          <div>
            {
              this.pastorsList.map((pastor, index) =>
                <PastorCard key={index} pastor={this.decoratePastor(pastor)} />
              )
            }
          </div>
        </div>
      );
    }
  }
}

export default graphql(getCurrentChurchPastors, {
  options: ({ selectedChurch }) => ({ variables: { churchId: selectedChurch.id } })
})(PastorsPage);



// WEBPACK FOOTER //
// ./src/components/pages/churchProfile/pastors/pastorsPage.js